export default "__VITE_ASSET__488ad7b3__"